import {
  CheckmarkOutline,
  ClockOutline,
  DollarOutline,
  HashOutline,
  PercentFill,
} from '@lyearn/icons';
import { formatNumberValue } from '@/modules/learner/views/LearnerProfile/components/LearnerActivities/utils/format';
import {
  KeyResultMetricEnum,
  MeasurementValueFormatEnum,
  OkrProgressComputationTypeEnum,
} from '@/types/schema';
import { getHumanDurationInHours } from '@/utils/time/getHumanDurationRounded';

const defaultFormatter = (value: number) => `${value}`;

export const KEY_RESULT_METRICS_CONFIG = {
  [KeyResultMetricEnum.Percentage]: {
    Icon: PercentFill,
    value: KeyResultMetricEnum.Percentage,
    labelKey: 'OKRs:Editor.Percentage',
    formatter: (value: number) => `${formatNumberValue(value)}%`,
  },
  [KeyResultMetricEnum.Number]: {
    Icon: HashOutline,
    value: KeyResultMetricEnum.Number,
    labelKey: 'OKRs:Editor.Number',
    formatter: formatNumberValue,
  },
  [KeyResultMetricEnum.Currency]: {
    Icon: DollarOutline,
    value: KeyResultMetricEnum.Currency,
    labelKey: 'OKRs:Editor.Dollars',
    formatter: (value: number) => `$${formatNumberValue(value)}`,
  },
  [KeyResultMetricEnum.Toggle]: {
    Icon: CheckmarkOutline,
    value: KeyResultMetricEnum.Toggle,
    labelKey: 'OKRs:Editor.Toggle',
    formatter: defaultFormatter,
  },
  [KeyResultMetricEnum.Time]: {
    Icon: ClockOutline,
    value: KeyResultMetricEnum.Time,
    labelKey: 'OKRs:Editor.Time',
    formatter: (value: number) => (value ? getHumanDurationInHours(value) : '0m'),
  },
  // Key results do not use 'Rate' metric. Adding here to make TS happy.
  // Rate metric is currently used by MGSA related activity metrics.
  [KeyResultMetricEnum.Rate]: {
    Icon: HashOutline,
    value: KeyResultMetricEnum.Rate,
    labelKey: 'OKRs:Editor.Number',
    formatter: formatNumberValue,
  },
};

const measurementValueFormatToMetricUnitMap: Record<
  MeasurementValueFormatEnum,
  KeyResultMetricEnum
> = {
  [MeasurementValueFormatEnum.Amount]: KeyResultMetricEnum.Currency,
  [MeasurementValueFormatEnum.Time]: KeyResultMetricEnum.Time,
};

export const getKeyResultMetricUnit = (
  metric: KeyResultMetricEnum,
  measurementValueFormat?: MeasurementValueFormatEnum | null | undefined,
) => {
  if (metric === KeyResultMetricEnum.Rate) {
    return measurementValueFormat
      ? measurementValueFormatToMetricUnitMap[measurementValueFormat]
      : KeyResultMetricEnum.Number;
  }
  return metric;
};

export const ICON_BASED_ON_COMPUTATION = {
  [OkrProgressComputationTypeEnum.IssueCount]: HashOutline,
  [OkrProgressComputationTypeEnum.StoryPointCount]: HashOutline,
  [OkrProgressComputationTypeEnum.IssueCompletion]: PercentFill,
  [OkrProgressComputationTypeEnum.StoryPointCompletion]: PercentFill,
};
